import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {Resource, ResourceBank, ResourceOptionCondition} from '../../../graphql/resources.datatypes';
import {gqlResource} from '../getResource.api';
import {CreditCardFee} from "../../../graphql/payments.datatypes";

interface ResourceOptionVars {
  id?: number
  internal_name: string
  display_name: string
  description: string
  disabled: boolean
  hidden: boolean
  additional_charge: boolean
  target: number
  action_type: number
  action_value?: string | null

  conditions?: {
    create?: ResourceOptionCondition[],
    update?: ResourceOptionCondition[],
    delete?: number[],
  }
}

export interface ResourceTourRoleVars {
  id?: number
  tour_role: number
  age_lower_bound: number
  age_upper_bound: number
}

export interface UpdateResourceVars {
  data: {
    id: number,
    internal_name?: string
    display_name?: string
    t_and_c_url?: string
    resource_type?: number | undefined
    disabled?: boolean
    parent_resource_id?: number
    has_dates?: boolean
    has_price?: boolean
    consumable?: boolean
    available_from?: string | null
    available_to?: string | null
    allow_manual_overbooking?: boolean
    show_on_invoice?: boolean
    description?: string
    locked?: boolean
    comms_email_address?: string
    max_additional_nights?: number
    max_nights_before?: number
    max_nights_after?: number
    guest_capacity?: number
    allow_multiple?: boolean
    rain_date_note?: string
    cancellation_policy?: string
    terms_and_conditions?: string
    contact_us_message?: string
    netsuite_tour_type?: string
    booking_tool_edit_cutoff?: string

    use_room_bank?: boolean
    room_bank_resource_id?: number

    resource_banks?: {
      create?: ResourceBank[],
      update?: ResourceBank[],
      delete?: number[],
    }

    options?: {
      create?: ResourceOptionVars[],
      update?: ResourceOptionVars[],
      delete?: number[],
    }

    tour_roles?: {
      create?: ResourceTourRoleVars[],
      update?: ResourceTourRoleVars[],
      delete?: number[],
    }

    credit_card_fee?: {
        create?: CreditCardFee,
        update?: CreditCardFee,
        delete?: number,
    },
  };
}

interface UpdateResourceData {
    __typename?: string,
    updateResource: Resource
}

export const UPDATE_RESOURCE_MUTATION = gql`
    mutation updateResource($data: UpdateResourceInput!) {
        updateResource(data: $data) {
            ${gqlResource}
        }
    }
`;

export const updateResource = () => useMutation<UpdateResourceData, UpdateResourceVars>(
  UPDATE_RESOURCE_MUTATION,
    {
        update: updateCacheByType('ResourceBank'),
    }
);

export default updateResource;
